module.exports = __webpack_public_path__ + "static/media/prepareddragonfruit.38c7d593.webp";